import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserStore} from '../../../authentication/state/user.store';
import {API_PATH, RouterLinks} from '../../constants';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid} from '../question-helper';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../../authentication/service/authentication.service';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import {dataURItoBlob} from '../../../shared/utilities';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Device } from '@capacitor/device';

declare const Dropzone: any;
declare const dropzonePreviewTemplate: any;
declare var $: any;

@Component({
    selector: 'app-question-uploaders-selfie',
    templateUrl: './question-uploaders-selfie.component.html',
    styleUrls: ['./question-uploaders-selfie.component.scss'],
    standalone: false
})
export class QuestionUploadersSelfieComponent implements OnInit, AfterViewInit {

  @Input() question: Question;
  @Input() noteText = 'Note on what to take images of';
  @Input() labelText; // = 'Upload Images';
  @Input() showNoteText = false;
  @Input() showUploadLabelText = false;
  @Input() uploadLabelText = '<strong>Format:</strong> &lt;jpg, jpeg, png, tiff, mp4&gt;&nbsp;';
  @Output() questionAnswer = new EventEmitter<any>();

  dropZone: any;
  acceptedFileTypes = 'image/*, video/*, application/pdf';
  fileSelectorEl = `question-uploader-${newGuid()}`;
  savedResources: any[] = [];
  device: any;
  constructor(
    private userStore: UserStore,
    private globalQuestionService: GlobalQuestionService,
    private authService: AuthenticationService,
    private router: Router,
    private httpClient: HttpClient
  ) {
  }

  ngOnInit(): void {
    this.acceptedFileTypes = 'image/*, video/*';
    
    //
    this.logDeviceInfo();

    this.authService.refreshToken()
      .subscribe(x => {
        this.userStore.update({
          access_token: x?.access_token,
          refresh_token: x?.refresh_token
        });
      });
  }
  logDeviceInfo = async () => {
    const info = await Device.getInfo();
    this.device = info;
    //this.takePicture();
  };
  takePicture = async () => {
    console.log(this.device);
    if (this.device.platform === 'web') return;
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      source: CameraSource.Prompt,
      resultType: CameraResultType.DataUrl
    });

    //var imageUrl = image.webPath;
   
    let file_ = dataURItoBlob(image.dataUrl);
    console.log(file_);
    const formData = new FormData();
    formData.append('file', file_,'media.png');
    

    this.httpClient.post<string>(API_PATH.UPLOAD_RESOURCE, formData).subscribe({
      next: data => {
          console.log(data);
      },
      error: error => {
          //this.errorMessage = error.message;
          console.error('There was an error!', error.error.text);
          this.savedResources.push({resource_id: error.error.text, file: error.error.text});
          this.question.answer = JSON.stringify(this.savedResources);
          this.questionAnswer.emit(this.question);
          const response = JSON.parse(this.question.answer);

      response.forEach((res: any) => {
        const resource_id = res.resource_id;
        this.globalQuestionService.getUploadedFileDetails(resource_id)
          .subscribe((details: any) => {
            if (!details) {
              return;
            }
            console.log(details)
            const mockFile = {
              name: details[0]?.original_filename,
              size: details[0]?.file_size
            };
            this.dropZone.emit('addedfile', mockFile);
            this.dropZone.emit('thumbnail', mockFile, `${API_PATH.UPLOAD_RESOURCE}/${resource_id}`);
            this.dropZone.emit('success', mockFile, resource_id);
            this.dropZone?.emit('complete', mockFile);
            this.dropZone.files.push(mockFile);
          });
      });
      }
  })
  }
  
  ngAfterViewInit(): void {
    this.dropZone = new Dropzone(`#${this.fileSelectorEl}`, {
      autoProcessQueue: true, // if false, call this.dropZone.processQueue()
      autoDiscover: false,
      acceptedFiles: this.acceptedFileTypes,
      previewTemplate: dropzonePreviewTemplate,
      thumbnailWidth: 204,
      thumbnailHeight: 204,
      maxFilesize: 200,
      capture: null,
      url: API_PATH.UPLOAD_RESOURCE,
      headers: {
        Authorization: `Bearer ${this.userStore.getValue()?.access_token}`
      },
    }).on('thumbnail', (file: any) => {
      $(file.previewElement).addClass('has-thumbnail');
    }).on('success', (file: any, response: any) => {
      if (!this.savedResources || this.savedResources?.length) {
        this.savedResources = [];
      }
      this.savedResources.push({resource_id: response, file: file?.upload?.uuid});
      this.question.answer = JSON.stringify(this.savedResources);
      this.questionAnswer.emit(this.question);
    }).on('removedfile', (file: any) => {
      const deletedFile = this.savedResources.find((item: any) => item.file === file?.upload?.uuid);
      if (deletedFile) {
        this.savedResources = this.savedResources.filter((item: any) => item.file !== file?.upload?.uuid);
        this.removeFile(deletedFile.resource_id);
        if (!this.savedResources || this.savedResources?.length) {
          this.question.answer = '';
          this.questionAnswer.emit(this.question);
        }
      }
    }).on('error', (file: any, response: any) => {
      if (response?.indexOf('401') !== -1) {
        this.router.navigate([RouterLinks.Login], {queryParams: {returnUrl: this.router.routerState.snapshot.url}});
      }
    });

    if (this.question?.answer) {
      let response: any;
      try { response = JSON.parse(this.question.answer); } catch { }
      if (!response) { return; }

      response.forEach((res: any) => {
        const resource_id = res.resource_id;
        this.globalQuestionService.getUploadedFileDetails(resource_id)
          .subscribe((details: any) => {
            if (!details) {
              return;
            }
            const mockFile = {
              name: details[0]?.original_filename,
              size: details[0]?.file_size
            };
            this.dropZone.emit('addedfile', mockFile);
            this.dropZone.emit('thumbnail', mockFile, `${API_PATH.UPLOAD_RESOURCE}/${resource_id}`);
            this.dropZone.emit('success', mockFile, resource_id);
            this.dropZone?.emit('complete', mockFile);
            this.dropZone.files.push(mockFile);
          });
      });
    }
  }

  removeFile(resource_id: string): void {
    this.globalQuestionService.removeFile(resource_id);
  }

}
